/**
 * 부동산 문의 서비스
 */
import { db } from '../firebase/config';
import {
  collection, addDoc, getDocs, query, where, orderBy, serverTimestamp,
} from 'firebase/firestore';

const COL = 'inquiries';

/** 문의 유형 */
export const INQUIRY_TYPES = [
  { key: 'account', label: '계정/가입' },
  { key: 'settlement', label: '정산/수수료' },
  { key: 'db', label: 'DB/구매' },
  { key: 'customer', label: '고객 관련' },
  { key: 'etc', label: '기타' },
];

export const STATUS_META = {
  pending: { label: '접수', color: '#F59E0B' },
  answered: { label: '답변 완료', color: '#22C55E' },
};

/** 문의 등록 */
export const createInquiry = async (data) => {
  const ref = await addDoc(collection(db, COL), {
    realtorId: data.realtorId,
    realtorName: data.realtorName || '',
    type: data.type || 'etc',
    title: data.title || '',
    content: data.content || '',
    status: 'pending',
    answer: '',
    answeredAt: null,
    createdAt: serverTimestamp(),
  });
  return ref.id;
};

/** 부동산별 내 문의 조회 */
export const getMyInquiries = async (realtorId) => {
  if (!realtorId) return [];
  try {
    const q = query(collection(db, COL), where('realtorId', '==', realtorId));
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
      createdAt: d.data().createdAt?.toDate?.()?.toISOString().slice(0, 10) || '',
    })).sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
  } catch {
    return [];
  }
};
